import { Upload, Brain, CheckCircle } from 'lucide-react';
import { SectionLabel } from '../common/SectionLabel';
import { Card } from '../common/Card';

const steps = [
  {
    icon: Upload,
    title: 'Submit',
    description: 'Upload your R&D proposal. Our system accepts detailed project documentation.',
  },
  {
    icon: Brain,
    title: 'AI Evaluates',
    description: 'Claude analyzes your proposal against our multi-framework evaluation rubric.',
  },
  {
    icon: CheckCircle,
    title: 'Decide',
    description: 'Receive structured feedback and clear recommendations for next steps.',
  },
];

export function HowItWorks() {
  return (
    <section className="py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <SectionLabel>How It Works</SectionLabel>
        <h2 className="text-3xl font-bold text-white mb-12">
          Structured Evaluation Process
        </h2>

        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((step, index) => (
            <Card key={step.title} variant="metric">
              <div className="flex items-center gap-3 mb-4">
                <span className="font-mono text-sm text-wolf-500">0{index + 1}</span>
                <step.icon className="w-6 h-6 text-action" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">{step.title}</h3>
              <p className="text-wolf-300">{step.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
